/**
 * data-grid.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';


const useStyles = makeStyles(theme => ({
  root: {
    width: props => props.width || 'auto',
    maxWidth: '100%',
    height: props => props.height || 'auto',
  },
  grid: {
    border: '1px solid transparent', // odd behavior if setting to none
    overflow: 'hidden',
    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
      padding: `0 ${theme.spacing(1.5)}`,
      '&:focus, &:focus-within': {
        outline: 'none'
      }
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: theme.palette.comp.dataGrid.headerBackground,
      '& .MuiDataGrid-columnHeaderTitle': {
        fontSize: theme.typography.sizes[1],
        lineHeight: '14px',
        whiteSpace: 'pre-line',
      },
      '& .MuiDataGrid-columnSeparator': {
        display: 'none '
      }
    },
    '& .MuiDataGrid-row': {
      backgroundColor: theme.palette.comp.dataGrid.rowBackground,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& .MuiDataGrid-cell': {
        borderBottom: `1px solid ${theme.palette.comp.dataGrid.headerBackground}`,
        [theme.breakpoints.down('sm')]: {
          fontSize: 13,
        },
      }
    }
  }
}));


export default function DataGrid(props) {
  const { 
    columns, 
    rows, 
    className, 
    width,
    maxHeight,
    headerHeight,
    rowHeight,
    hideFooter,
    ...rest 
  } = props;
  const hHeight = headerHeight || 52;
  const rHeight = rowHeight || 44;
  const fHeight = hideFooter ? 0 : 52;  
  // due to a data-grid flickering bug we have to ensure the parent container
  // is never < 20px larger than the contained grid height.
  const tableHeight = hHeight + (rHeight * rows.length) + fHeight + 20;
  const height = !maxHeight 
    ? null
    : maxHeight < tableHeight && maxHeight > tableHeight - 20
      ? tableHeight
      : Math.min(maxHeight, tableHeight);
  const classes = useStyles({ width: width || 'auto', height: height || 'auto' });
  

  return (
    <div className={classes.root}>
      <MuiDataGrid
        className={`${className || ''} ${classes.grid}`}
        columns={columns}
        rows={rows}
        columnHeaderHeight={hHeight}
        rowHeight={rHeight}
        hideFooter={hideFooter}
        {...rest}
      />
    </div>
  );
}